/** api/chat sözleşmesi (DAL ChatController). */
export interface ChatAttachment {
  attachmentId: string;
  fileName: string;
  size: number;
  contentType: string | null;
  url: string;
}

export interface ChatReaction {
  emoji: string;
  userIds: string[];
}

export interface ChatReply {
  messageId: string;
  senderId: string;
  senderName: string | null;
  preview: string;
}

export type ChatMessageType = 'text' | 'file' | 'image' | 'share' | 'system' | 'deleted';

export interface ChatMessage {
  messageId: string;
  senderId: string;
  senderName: string | null;
  recipientId: string | null;
  groupId: string | null;
  content: string;
  type: ChatMessageType;
  payload: string | null;
  sentAt: string;
  editedAt: string | null;
  deleted: boolean;
  replyTo: ChatReply | null;
  attachments: ChatAttachment[];
  reactions: ChatReaction[];
  readAt: string | null;
  readCount: number;
  recipientCount: number;
  /** Yalnız istemcide: gönderiliyor / gönderilemedi. */
  pending?: 'sending' | 'failed';
}

export interface ChatConversation {
  /** "u:<userId>" ya da "g:<groupId>" */
  key: string;
  kind: 'user' | 'group';
  peerUserId?: string;
  groupId?: string;
  title: string | null;
  memberCount?: number;
  lastMessage: {
    messageId: string;
    sentAt: string;
    content: string;
    type: ChatMessageType;
    senderId: string;
    senderName?: string | null;
  } | null;
  unread: number;
}

export interface ChatContact {
  userId: string;
  userCode: string;
  userName: string;
  roleName: string | null;
  isOnline: boolean;
  lastActiveAt: string | null;
}

export interface ChatGroupDetail {
  messageGroupId: string;
  groupName: string;
  createdAt: string;
  createdByUserId: string | null;
  members: { userId: string; userCode: string; userName: string }[];
}

/** Ekran paylaşımı (mesaj türü "share") yükü. */
export interface SharePayload {
  v: 1;
  screenId: string;
  caption: string;
  /** Uygulama içi adres: /s/<screenId>?f=<durum> */
  url: string;
  /** Kısa açıklama: "3 filtre · 'elma' araması" */
  summary?: string;
  rowCount?: number;
}

export const conversationKeyOf = (m: Pick<ChatMessage, 'groupId' | 'senderId' | 'recipientId'>, me: string) =>
  m.groupId ? `g:${m.groupId}` : `u:${m.senderId.toLowerCase() === me.toLowerCase() ? m.recipientId : m.senderId}`;

export const parseKey = (key: string): { peerUserId?: string; groupId?: string } =>
  key.startsWith('g:') ? { groupId: key.slice(2) } : { peerUserId: key.slice(2) };
